const layerInfo = [
    {
        name:"layerItem",
        el:"#layer-item",
        btn:".p-btn__item",
        render:true
    },
    {
        name:"layerSkill",
        el:"#layer-skill",
        btn:".p-btn__skill",
        render:true
    }
];

export default layerInfo;


// WEBPACK FOOTER //
// ./src/js/classchange/layer-info.js